<template>
  <div>
    <headerNotice routerName="编辑等级"></headerNotice>
    <!-- 基本信息 -->
    <div class="baseInfo" v-loading="loading">
      <!-- <h1>
        基本信息
        <span>
          （&nbsp;
          <i class="mustStar">*</i>&nbsp;必填）
        </span>
      </h1>-->
      <div class="table">
        <el-form :model="formData" class="signUp_Form" label-width="200px">
          <el-row>
            <el-col :span="10">
              <el-form-item label="分销等级名称：" :rules="{'required':true}">
                <el-input
                  v-model="formData.levelName"
                  size="small"
                  placeholder="请输入分销等级名称，小于50个字"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="佣金满足点：" :rules="{'required':true}">
                <el-input
                  type="number"
                  v-model="formData.minSatisfactionPoint"
                  size="small"
                  placeholder="设置获得总佣金达到多少金额后，自动升级到此等级"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="下线人数：" :rules="{'required':true}">
                <el-input
                  type="number"
                  v-model="formData.downCount"
                  size="small"
                  placeholder="设置下线人数达到后，自动升级到此等级"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="作为上一级佣金奖励：" :rules="{'required':true}">
                <el-input
                  type="number"
                  v-model="formData.oneCommission"
                  size="small"
                  placeholder="设置作为上一级分销商除了获得商品本身的上一级佣金比例外，额外获得的佣金比例"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="作为上二级佣金奖励：" :rules="{'required':true}">
                <el-input
                  type="number"
                  v-model="formData.twoCommission"
                  size="small"
                  placeholder="设置作为上二级分销商除了获得商品本身的上二级佣金比例外，额外获得的佣金比例"
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="备注：" :rules="{'required':true}">
                <el-input
                  rows="2"
                  type="textarea"
                  v-model="formData.remark"
                  placeholder
                  maxlength="50"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="10">
              <el-form-item label="是否默认等级：" :rules="{'required':true}">
                <el-switch v-model="formData.isDefaultLevelbool" active-text="是" inactive-text="否"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 保存 -->
      <div class="saveBox">
        <el-button
          type="primary"
          :loading="btnLoading"
          class="add"
          @click="editDistributionLevelConfig()"
        >编辑等级</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import headerNotice from "./../../components/common/headerNotice.vue";
export default {
  data() {
    return {
        loading:false,
      btnLoading: false,
      items: {},
      formData: {
        distributionLevelID: 0,
        level: 0,
        levelName: "",
        minSatisfactionPoint: "",
        downCount: "",
        oneCommission: "",
        twoCommission: "",
        remark: "",
        isDefaultLevelbool: false
      },

      headers: {
        Authorization: localStorage.getItem("accessToken")
      }
    };
  },
  components: {
    headerNotice
  },
  created() {
    if (this.$route.query.distributionLevelID) {
      this.formData.distributionLevelID = this.$route.query.distributionLevelID;
    }
  },
  mounted() {
    this.getDistributionLevelConfig();
  },
  methods: {
    //获取等级详情
    getDistributionLevelConfig() {
        let self = this;
      $http.GET({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/DistributionLevelConfig/GetDistributionLevel?Id="+self.formData.distributionLevelID,
          //params: { Id: this.distributionLevelID },
        //data: {this.distributionLevelID},
        success(res) {
          self.formData = res;
        },
        fail(res) {
        }
      });
    },

    //编辑等级
    editDistributionLevelConfig() {
      let self = this;
      this.btnLoading = true;
      this.formData.isDefaultLevel = 2;
      if (this.formData.isDefaultLevelbool) {
        this.formData.isDefaultLevel = 1;
      }
      $http.PUT({
        url:
          this.$store.state.apiUrl +
          "/api/services/app/DistributionLevelConfig/UpdateDistributionLevel",
        data: this.formData,
        success(res) {
          self.$message({
            message: "添加成功",
            type: "success"
          });
          self.$router.push({
            path: "/distributionLevelConfig"
          });
          self.btnLoading = false;
        },
        fail(res) {
            console.log(res);
          self.btnLoading = false;
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
// 基本信息
.baseInfo {
  margin: 20px 50px;
  border: 1px solid #c5c5c5;
  h1 {
    background: #f3f3f3;
    padding: 10px 20px;
    span {
      font-size: 12px;
      color: #999;
      i {
        font-style: normal;
      }
    }
  }
  .table {
    margin-top: 20px;
    .displayCate {
      display: flex;
      flex-direction: column;
      border: 1px solid #999;
      li {
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid #999;
        box-sizing: border-box;
        padding: 0 20px;
        &:nth-last-child(1) {
          border: none;
        }
        .firstName {
          font-size: 18px;
          color: #000;
        }
        .groupBox {
          padding-left: 40px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          /deep/ .radio {
            margin: 0 20px 10px 0;
          }
        }
      }
    }
  }
  .goodsBox {
    padding: 20px;
  }
  .specification {
    margin-top: 20px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    table {
      width: 100%;
      table-layout: fixed;
      word-break: break-all;
      border: 1px solid #ccc;
      thead {
        width: 100%;
        th {
          height: 50px;
          font-size: 14px;
          color: #666;
          border: 1px solid #ccc;
        }
      }
      tbody tr {
        border: 1px solid #ccc;
        td {
          height: 50px;
          border: 1px solid #ccc;
          vertical-align: middle;
          text-align: center;
          textarea {
            width: 80%;
            appearance: none;
            outline: none;
            border: none;
            min-height: 100px;
            background: #f9f9f9;
            resize: none;
          }
          input {
            text-align: center;
            width: 95%;
            height: 80%;
            outline: none;
            border: none;
            background: #f9f9f9;
          }
          img {
            display: inline-block;
            width: 100px;
            height: 100px;
            cursor: pointer;
          }
          &.spePic {
            padding: 10px;
          }
        }
      }
    }
    .addSpecification {
      margin: 20px 0;
    }
  }
  .saveBox {
    border-top: 1px solid #c5c5c5;
    width: 100%;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .linkIpt {
    padding: 15px 50px;
  }
}
</style>
<style>
</style>
